import { render, staticRenderFns } from "./tournamentPractice.vue?vue&type=template&id=19ba9867&"
import script from "./tournamentPractice.vue?vue&type=script&lang=js&"
export * from "./tournamentPractice.vue?vue&type=script&lang=js&"
import style0 from "./tournamentPractice.vue?vue&type=style&index=0&id=19ba9867&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports